import { render, staticRenderFns } from "./summary-main.vue?vue&type=template&id=f28d2218"
import script from "./summary-main.vue?vue&type=script&lang=js"
export * from "./summary-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports